import CrudPage from "../../Components/CrudPage"
import React, { useState, useEffect, useRef } from "react";
import { useModal } from "../../Components/Modal"
import AdminController from "../../APIController/AdminController"
import Text from "../../Components/Text";
import TIcon from "../../Components/TIcon";
import AdminManagement from "./AdminManagement";
const AllUserManagement = () => {
    const [user, setUser] = useState([])
    const { ModalView, openModal, closeModal } = useModal()
    const { getAllUser } = AdminController()

    useEffect(() => {
        fetchUser()
    }, [])

    const fetchUser = async () => {
        const data = await getAllUser()
        setUser(data)
    }

    const roleLabel = (user, roleName) =>{
        if (user.role == "ADMIN" || roleName == "ADMIN") return "Software Administrator"
        return "Nutzer"
    }

    const afterSubmit = () =>{
        fetchUser()
        closeModal()
    }

    const handleEditClick = (e, user) =>{
        openModal(<AdminManagement user={user} afterAction={() => afterSubmit()} />)
    }

    return (
        <>
            <CrudPage
                title={"User"}
                items={user}
                displayMethod={(item) => (
                    <>
                    <div className="flex flex-row gap-2 flex-1">
                        <Text type="itemmain">{item.firstName}</Text>
                        <Text type="itemmain">{item.lastName}</Text>
                        {item.active && (
                            <TIcon name={"check"} color="green" />
                        )}
                    </div>
                    <Text type="itemmain">{item.email}</Text>
                    <Text type="itemtext">{`${roleLabel(item, item.role)}`}</Text>
                    </>
                )}
                crudActions={[
                    { type: "edit", color: "black", action: handleEditClick, icon: "edit" },
                ]}
                isAdminPage={true}
            />
            <ModalView classNames="w-auto" />
        </>
    )
}
export default AllUserManagement